import { ICommand, IDefineCommand } from 'core-ts-types';
import { AuthenticationQueryModel } from '../queries/authentication_query_model';
import { URLQueryModel } from '../queries/url_query_model';
import { MemberConfigurationDatastore } from '../datastore/member_configuration_datastore';

angular
  .module('data-ng-authentication')
  .factory(
    'loginConfigurationCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      ngAuthenticationQueryModel: AuthenticationQueryModel,
      ngURLQueryModel: URLQueryModel,
      ngMemberConfigurationDatastore: MemberConfigurationDatastore,
      synchronizeDeprecatedModelsCommand: ICommand
    ) =>
      defineCommand('loginConfigurationCommand', (deferred) => {
        if (ngAuthenticationQueryModel.isMemberValid()) {
          deferred.resolve(ngMemberConfigurationDatastore.store);
          return;
        }

        $http
          .get(ngURLQueryModel.getLoginConfigurationUrl())
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            const loginConfiguration = response.data.login_config;
            ngMemberConfigurationDatastore.update(loginConfiguration);
            synchronizeDeprecatedModelsCommand();

            if (ngAuthenticationQueryModel.isMemberValid()) {
              deferred.resolve(response.data.login_config);
            } else {
              deferred.reject();
            }
          })
          .catch((response: ng.IHttpPromiseCallbackArg<any>) => {
            return deferred.reject({
              reason: response.data.detail
            });
          });
      })
  )
  .factory('loginConfigCommand', (loginConfigurationCommand: ICommand) => loginConfigurationCommand);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/commands/login_config_command.ts